import { useMemo, useState } from 'react'; 
import { graphql, useStaticQuery } from 'gatsby';
import { window } from 'browser-monads';
import { ContextService } from '../components/hoc/context/product/context';
import { PerformerType } from '../components/hoc/constants/performer.constants';
import { isStaticNavigation } from '../components/utilities/mock';

export default function useConfiguration() : ContextService {
    const data = useStaticQuery(graphql`
		query ConfigQueryq {
			context: file(name: { eq: "context" }) {
				childPlainText {
					content
				}
			}
			translation: file(name: { eq: "translation_default" }) {
				childPlainText {
					content
				}
			}
			caregiver: file(name: { eq: "translation_caregiver_default" }) {
				childPlainText {
					content
				}
			}
			patient: file(name: { eq: "translation_patient_default" }) {
				childPlainText {
					content
				}
			}
			pages: file(name: { eq: "pages-config" }) {
				childPlainText {
					content
				}
			}
			form: file(name: { eq: "forms-config" }) {
				childPlainText {
					content
				}
			}
			questions: file(name: { eq: "questions-config" }) {
				childPlainText {
					content
				}
			}
			footer: file(name: { eq: "footer-config" }) {
				childPlainText {
					content
				}
			}
		}
	`);

	const configuration = useMemo(() => ({
		...JSON.parse(data.context.childPlainText.content),
		...JSON.parse(data.form.childPlainText.content),
		...JSON.parse(data.pages.childPlainText.content),
		...JSON.parse(data.footer.childPlainText.content),
		...JSON.parse(data.questions.childPlainText.content),
	}), [data]);

	let performerQuery: Array<string> | null = null;
	if ( isStaticNavigation() ) {
		performerQuery = window.location.search.match(/(?:\?|&)performer=([^&]+)/);
	}
	const [performer, setPerformer] = useState(performerQuery ? performerQuery[1] : PerformerType.PATIENT);
	const contextService = useMemo(() => {
        return new ContextService(
			configuration,
			JSON.parse(data.translation.childPlainText.content),
			setPerformer,
			JSON.parse(
                performer === PerformerType.CAREGIVER
                ? data.caregiver.childPlainText.content
                : data.patient.childPlainText.content
            )
		);
    }, [data, configuration, performer]);

    return contextService;
}

